export enum ADMISSION_REQUEST_STATUS {
    RETURNED = 'admissionRequestReturned',
    OPEN = 'requestOpen',
    COMPLETED = 'requestCompleted',
    REJECTED = 'admissionRequestRejected'
}

export enum ADMISSION_REQUEST_STATUS_BG {
    RETURNED = '#4f0b8a33',
    OPEN = '#ff6a3933',
    COMPLETED = '#00c48c33',
    REJECTED = 'rgba(251, 55, 94, 0.2)'
}

export enum ADMISSION_REQUEST_STATUS_COLOR {
    RETURNED = '#4F0B8A',
    OPEN = '#ff6a39',
    COMPLETED = '#00c48c',
    REJECTED = 'rgba(251, 55, 94, 1)'
}

export enum ADMISSION_BACKEND_REQUEST_STATUS {
    RETURNED = 'RETURNED',
    OPEN = 'OPEN',
    COMPLETED = 'COMPLETED',
    REJECTED = 'REJECTED'
}
